import type {
  CustomerInput, CustomerListItem, CustomerPaymentInput, CustomerStatementEntry,
  Paginated, PaginationInput,
} from '@najah/core'
import { api } from './api'

export interface CustomerOption {
  id: string
  fullName: string
  phone: string
  creditLimit: number
}

export interface CustomerDetail {
  id: string
  phone: string
  fullName: string
  email: string | null
  address: string | null
  notes: string | null
  openingBalance: number
  creditLimit: number
  isActive: boolean
  balance: number
  hasAppAccount: boolean
  createdAt: string
}

export const customersApi = {
  list: (query: Partial<PaginationInput> & { withDebt?: boolean }) =>
    api<Paginated<CustomerListItem>>('/customers', {
      query: query as Record<string, string | number | boolean | undefined>,
    }),
  options: () => api<CustomerOption[]>('/customers/options'),
  totalDebt: () => api<{ totalDebt: number }>('/customers/total-debt'),
  get: (id: string) => api<CustomerDetail>(`/customers/${id}`),
  statement: (id: string) =>
    api<{ customer: CustomerDetail; entries: CustomerStatementEntry[]; balance: number }>(
      `/customers/${id}/statement`,
    ),
  create: (body: CustomerInput) => api<{ id: string }>('/customers', { method: 'POST', body }),
  update: (id: string, body: CustomerInput) => api<CustomerDetail>(`/customers/${id}`, { method: 'PATCH', body }),
  remove: (id: string) => api<{ success: boolean }>(`/customers/${id}`, { method: 'DELETE' }),
  pay: (body: CustomerPaymentInput) =>
    api<{ id: string; reference: string; amount: number; remainingBalance: number }>('/customers/payments', {
      method: 'POST',
      body,
    }),
}
